import clsx from "clsx";
import { useState } from "react";
import { Dropdown } from "@/components/Dropdown/Dropdown";
import { AppText } from "@/components/Text/AppText";
import { UserJobStatus } from "@/types/userJob";

const StatusItem = ({
    title,
    colour,
    bgColor,
}: {
    title: string;
    colour: string;
    bgColor: string;
}) => {
    return (
        <div className="flex items-center gap-2">
            <div className={clsx("h-2 w-2 rounded-full", bgColor)} />
            <AppText
                variant="labelsbuttons"
                className={colour}
            >
                {title}
            </AppText>
        </div>
    );
};

const statusDropdownOptions = [
    {
        title: (
            <StatusItem
                title="Applying"
                colour="text-neutral-900"
                bgColor="bg-neutral-900"
            />
        ),
        id: "Applying",
        colour: "text-neutral-900",
    },
    {
        title: (
            <StatusItem
                title="Applied"
                colour="text-primary-900"
                bgColor="bg-primary-900"
            />
        ),
        id: "Applied",
        colour: "text-primary-900",
    },
    {
        title: (
            <StatusItem
                title="Interviewing"
                colour="text-alert-800"
                bgColor="bg-alert-800"
            />
        ),
        id: "Interviewing",
        colour: "text-alert-800",
    },
    {
        title: (
            <StatusItem
                title="Negotiating"
                colour="text-primary-500"
                bgColor="bg-primary-500"
            />
        ),
        id: "Negotiating",
        colour: "text-primary-400",
    },
    {
        title: (
            <StatusItem
                title="Accepted"
                colour="text-success-900"
                bgColor="bg-success-900"
            />
        ),
        id: "Accepted",
        colour: "text-success-900",
    },
    {
        title: (
            <StatusItem
                title="Rejected"
                colour="text-error-700"
                bgColor="bg-error-700"
            />
        ),
        id: "Rejected",
        colour: "text-error-700",
    },
];

export const JobStatusSelector = ({
    status,
    onChange,
    readOnly = false,
}: {
    status: UserJobStatus;
    onChange: (status: UserJobStatus) => void;
    readOnly?: boolean;
}) => {
    const [selectedStatus, setSelectedStatus] = useState<UserJobStatus>(status);

    const handleStatusChange = (status: string) => {
        setSelectedStatus(status as UserJobStatus);
        onChange(status as UserJobStatus);
    };

    const activeItem = statusDropdownOptions.find(
        option => option.id === selectedStatus,
    );

    const renderStatusTitle = (status: UserJobStatus) => {
        const statusItem = statusDropdownOptions.find(
            option => option.id === status,
        );
        return statusItem?.title;
    };

    return readOnly ? (
        <AppText
            variant="labelsbuttons"
            className={activeItem?.colour}
        >
            {selectedStatus}
        </AppText>
    ) : (
        <Dropdown
            items={statusDropdownOptions}
            activeId={selectedStatus}
            handleChange={handleStatusChange}
            title={renderStatusTitle(selectedStatus)}
            className="w-[165px]"
        />
    );
};
